@if (nextButtonClicked) {
  <app-global-validation-message [formInput]="form"> </app-global-validation-message>
}
<form [formGroup]="form" class="form">
  <div class="preamble"><h2>Channel dimensions</h2></div>

  <ul class="questions">
    <li class="group">
      <fieldset>
        <ol class="questions">
          <li class="required">
            <label for="reason">
              <span class="label">Width (metres)</span>
              <abbr title="(required)" class="required">*</abbr>
              @if (!isWidthPresentValid && form.dirty) {
                <em class="red-alert">Width is required</em>
              }
              @if (!isWidthRangeValid && form.dirty) {
                <em class="red-alert">Width must be greater than zero</em>
              }
              @if (!isWidthRangeMaxValid && form.dirty) {
                <em class="red-alert">Width must be less than or equal to {{widthMax}}</em>
              }
            </label>
            <input type="number" size="20" min="0" step="any" required name="width" id="width" formControlName="width"/>
          </li>
        </ol>
      </fieldset>
    </li>
  </ul>

  @if (changeDimensionsData.exchangeAreaRequired) {
    <div class="alert alert-info">
      <h2>Exchange area required</h2>
      <p>You may be required to provide an exchange area. This will involve making the exchange area a Category A area.</p>
    </div>
  }

  <li class="footer">
    <ul class="actions">
      <li>
        <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" />
      </li>
      <li>
        <em><input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /></em>
      </li>
    </ul>
  </li>
  <ul class="actions">
    <li>
      <a href (click)="cancel()">Cancel</a>
    </li>
  </ul>
</form>
